import { AuthService, type SsoLoginBodyDto } from 'app/API';
import type { TCall } from 'app/queries/types/TCall';

type TParams = {
  call: TCall;
  onError: (message: string) => void;
  requestBody: SsoLoginBodyDto;
};

export const ssoLogin = ({ call, onError, requestBody }: TParams) =>
  call(() => AuthService.ssoLogin({ requestBody }), {
    dontCatchErrors: true,
    onError,
  });
